import React from 'react';

import { EntityContext } from 'context/entityContext';
import pluralize from 'helpers/pluralize';

import RadioKPIs from 'components/data-containers/KPIs/Radio/RadioKPIs';

import Message from 'components/base/Message/Message';
import Layout from 'components/styled/Layout/Layout';

import MapSkeletonLoader from 'components/data-containers/ChoroplethMap/shared/SkeletonLoader';
import PerformanceTrendSkeleton from 'components/data-containers/PerformanceTrend/SkeletonLoader';
import RadioActivitySkeletonLoader from 'components/data-containers/RadioActivity/SkeletonLoader';

const RadioPerformanceTrend = React.lazy(() =>
  import('components/data-containers/PerformanceTrend/RadioPerformanceTrend')
);

const RadioSpinsMap = React.lazy(() =>
  import('components/data-containers/ChoroplethMap/RadioSpinsMap')
);

const RadioActivity = React.lazy(
  () => import('components/data-containers/RadioActivity/RadioActivity') as any
);

const Radio: React.FC = () => {
  const ctx = React.useContext(EntityContext);
  const { compareMode, entityType } = ctx;

  return (
    // Note: Do not remove the next <div>. It avoids flexbox to double margins between generic components.
    <div>
      <RadioKPIs {...ctx} />
      <React.Suspense
        fallback={
          <PerformanceTrendSkeleton
            title="Radio Performance"
            showPeriodDropdown
            toggleOptions={[
              { value: 'aggregate', label: 'Overall', active: true },
              { value: 'all', label: 'By US Format', active: false },
            ]}
            isNarrowScreen
          />
        }
      >
        <RadioPerformanceTrend {...ctx} />
      </React.Suspense>

      <React.Suspense fallback={<MapSkeletonLoader title="Radio Spins Map" />}>
        <RadioSpinsMap {...ctx} />
      </React.Suspense>

      {!compareMode && (
        <React.Suspense fallback={<RadioActivitySkeletonLoader />}>
          <RadioActivity />
        </React.Suspense>
      )}

      {compareMode && (
        <Layout.MaxWidth>
          <Message data-pw="MessageBlock">
            Radio Activity is not available in compare{' '}
            {pluralize(compareMode === 'country' ? compareMode : entityType)}{' '}
            mode. Exit compare mode to see Radio Activity for this {entityType}.
          </Message>
        </Layout.MaxWidth>
      )}
    </div>
  );
};

export default Radio;
